module.exports = __webpack_public_path__ + "img/report-6.1c0f9db4.jpg";